import React, { useState, useEffect, useRef } from 'react';
import { FiPlus, FiX } from 'react-icons/fi';
import '../styles/editModal.css';
import '../styles/leagueManagement.css';
import '../styles/partners.css';
import { BASE_URL } from '../constants/config';

const MAX_LOGO_BYTES = 1024 * 1024;

// Поля leagues, которые заводит админ.
// league_type не спрашиваем: он живёт в league_settings и задаётся на сезоне,
// в саму leagues пишем 1 по умолчанию — на поведение это не влияет.
export default function CreateLeagueModal({
    isOpen, onClose, onCreate, championat, seasonsCatalog, existingNames, clientLogo,
}) {
    const [name, setName] = useState('');
    const [logoFile, setLogoFile] = useState(null);
    const [logoPreview, setLogoPreview] = useState('');
    const [activeSeason, setActiveSeason] = useState('');
    const [priority, setPriority] = useState('1');
    const [enabled, setEnabled] = useState(true);
    // Основной логотип — clients.image клиента чемпионата
    const [useClientLogo, setUseClientLogo] = useState(false);
    const [error, setError] = useState(null);
    const fileInputRef = useRef(null);

    useEffect(() => {
        if (!isOpen) return;
        setName('');
        setLogoFile(null);
        setActiveSeason('');
        setPriority('1');
        setEnabled(true);
        setUseClientLogo(false);
        setError(null);
        if (fileInputRef.current) fileInputRef.current.value = '';
    }, [isOpen]);

    useEffect(() => {
        if (!logoFile) {
            setLogoPreview('');
            return undefined;
        }
        const url = URL.createObjectURL(logoFile);
        setLogoPreview(url);
        return () => URL.revokeObjectURL(url);
    }, [logoFile]);

    if (!isOpen || !championat) return null;

    const parsedPriority = parseInt(priority, 10);
    const clientLogoUrl = clientLogo
        ? (clientLogo.startsWith('http') ? clientLogo : BASE_URL.url + clientLogo)
        : '';
    const shownLogo = useClientLogo ? clientLogoUrl : logoPreview;

    const pickFile = (e) => {
        const file = e.target.files && e.target.files[0];
        e.target.value = '';
        if (!file) return;
        if (!file.type.startsWith('image/')) {
            setError('Нужен файл изображения.');
            return;
        }
        if (file.size > MAX_LOGO_BYTES) {
            setError('Файл больше 1 МБ — выберите поменьше.');
            return;
        }
        setError(null);
        setUseClientLogo(false);
        setLogoFile(file);
    };

    const clearLogo = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setLogoFile(null);
        setUseClientLogo(false);
        if (fileInputRef.current) fileInputRef.current.value = '';
    };

    const submit = () => {
        const trimmed = name.trim();
        if (!trimmed) {
            setError('Введите название лиги.');
            return;
        }
        if (existingNames.includes(trimmed)) {
            setError('Лига с таким названием уже есть в этом чемпионате.');
            return;
        }
        if (isNaN(parsedPriority) || parsedPriority < 0) {
            setError('Приоритет должен быть целым числом от 0.');
            return;
        }
        onCreate({
            name: trimmed,
            championat_id: championat.id,
            league_type: 1,
            active_season: activeSeason === '' ? null : parseInt(activeSeason, 10),
            priority: parsedPriority,
            enabled: enabled ? 1 : 0,
            logoFile: useClientLogo ? null : logoFile,
            image: useClientLogo && clientLogo ? clientLogo : '',
        });
        onClose();
    };

    return (
        <div className="modalOverlay" onClick={onClose}>
            <div className="modalContent modalContentWide" onClick={(e) => e.stopPropagation()}>
                <div className="modalHeader">
                    <h2>Новая лига в «{championat.name}»</h2>
                    <button className="modalClose" onClick={onClose}>×</button>
                </div>
                <div className="modalBody modalBodyScroll">
                    <div className="lmRow">
                        <label className="modalLabel">Название лиги</label>
                        <input
                            type="text"
                            className="modalInput"
                            maxLength={100}
                            value={name}
                            placeholder="например «Премьер лига»"
                            autoFocus
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>

                    <div className="lmRow">
                        <label className="modalLabel">Логотип</label>
                        <input
                            ref={fileInputRef}
                            type="file"
                            accept="image/*"
                            className="logoSquareInput"
                            onChange={pickFile}
                        />
                        {shownLogo ? (
                            <div className="logoSquare logoSquareFilled">
                                <img src={shownLogo} alt="" />
                                <button
                                    type="button"
                                    className="logoSquareHit"
                                    onClick={() => fileInputRef.current && fileInputRef.current.click()}
                                >
                                    Сменить
                                </button>
                                <button
                                    type="button"
                                    className="logoSquareRemove"
                                    aria-label="Убрать логотип"
                                    onClick={clearLogo}
                                >
                                    <FiX />
                                </button>
                            </div>
                        ) : (
                            <button
                                type="button"
                                className="logoSquare"
                                onClick={() => fileInputRef.current && fileInputRef.current.click()}
                            >
                                <FiPlus />
                                <span>Добавить логотип</span>
                            </button>
                        )}
                        <span className="fieldHint">PNG или JPG до 1 МБ.</span>
                        {clientLogo && (
                            <label className="ptClientLogo">
                                <input
                                    type="checkbox"
                                    checked={useClientLogo}
                                    onChange={(e) => {
                                        setUseClientLogo(e.target.checked);
                                        if (e.target.checked) setLogoFile(null);
                                    }}
                                />
                                <img src={clientLogoUrl} alt="" />
                                Использовать основной лого
                            </label>
                        )}
                    </div>

                    {/* <div className="lmRow">
                        <label className="modalLabel">Активный сезон</label>
                        <select
                            className="modalInput"
                            value={activeSeason}
                            onChange={(e) => setActiveSeason(e.target.value)}
                        >
                            <option value="">— не выбран —</option>
                            {seasonsCatalog.map(s => (
                                <option key={s.season_id} value={s.season_id}>{s.season_name}</option>
                            ))}
                        </select>
                        <span className="fieldHint">
                            Можно оставить пустым и задать позже, когда заведёте сезон в лиге.
                        </span>
                    </div> */}

                    <div className="lmRow">
                        <label className="modalLabel">Приоритет</label>
                        <input
                            type="number"
                            className="modalInput inputNarrow"
                            min={0}
                            value={priority}
                            onChange={(e) => setPriority(e.target.value)}
                        />
                        <span className="fieldHint">
                            Чем меньше число, тем выше лига в списке.
                        </span>
                    </div>

                    <div className="lmRow">
                        <div className="switchRow">
                            <div className="switchText">
                                <span className="switchTitle">Видна в приложении</span>
                                <span className="fieldHint">
                                    Выключенная лига остаётся в базе, но скрыта от пользователей.
                                </span>
                            </div>
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    checked={enabled}
                                    onChange={(e) => setEnabled(e.target.checked)}
                                />
                                <span className="switchSlider" />
                            </label>
                        </div>
                    </div>

                    {error && <span className="fieldError">{error}</span>}
                </div>
                <div className="modalFooter">
                    <button className="modalButton modalButtonCancel" onClick={onClose}>
                        Отмена
                    </button>
                    <button className="modalButton modalButtonSave" onClick={submit}>
                        Создать лигу
                    </button>
                </div>
            </div>
        </div>
    );
}
